import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common'

@Injectable()
export class MessagingProvider {
  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) {}

  private _url: string = this.commonProvider.apiUrl + 'api/v1/messaging';
  
  getMessages(recipient_id): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._url + '/get', recipient_id);
  }

  getUsers(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._url + '/list');
  }

  sendMessage(message): Observable<Response<any>> {
        return this.http.post<Response<any>>(this._url + `/send`, message);
  }

}




// WEBPACK FOOTER //
// ./src/providers/messaging/messaging.ts